module.exports = __webpack_public_path__ + "img/FQSP02.7b577498.svg";